export const openModal = () =>{
    document.getElementById('subscribe').style.display='block'      
     
 
 }